module.exports = __webpack_public_path__ + "assets/img/home-box1-bg.e7797dfd.png";